import { Component, OnDestroy, ElementRef, OnInit, ViewChild , Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { takeUntil } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { APPCONFIG } from '../../../config';
import { HttpService } from '../../../services/http.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AbortJobDialog } from '../EPW/abort_job/abort_job.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { sessionConfirmDialogComponent } from '@fuse/components/confirm-dialog-session/confirm-dialog-session.component';
@Component({
    selector: 'EPW',
    templateUrl: './epw.component.html?v=${APPCONFIG.cacheVersion}',
    styleUrls: ['./epw.component.scss?v=${APPCONFIG.cacheVersion}'],
    animations: fuseAnimations,
})
export class epwComponent implements OnInit, OnDestroy {
    readonly main_app_logo = APPCONFIG.main_app_logo;
    @ViewChild(SignaturePad) signaturePad: SignaturePad;
    @ViewChild('inputFile') myInputVariable: ElementRef;
    uploadedImage;
    confirmDialogRefSession: MatDialogRef<sessionConfirmDialogComponent>;
    jobPkId: any;
    result;
    title;
    imageSrc: String;
    bytesList;
    sign: boolean = false;
    dataImg;
    loginForm: FormGroup;
    loginFormErrors: any;
    vehicleId;
    jobStatus:any;
    postDataClear: boolean = false;
    jobData;
    jobApiData = {};
    profileForm: any;
    jobInputs: boolean = true;
    imageSrcData: any;
    job;
    message: string;
    isValide: boolean = false;
    detailPage: boolean = false;
    detailPageSubmit: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public route: ActivatedRoute,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public _matDialogRef: MatDialogRef<any>,
        public dialog: MatDialog,
        private http1: HttpService,
        private spinner: NgxSpinnerService,
        private _router: Router,
        private abortjobDialog:AbortJobDialog,
        private ng2ImgMax: Ng2ImgMaxService,
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder, private http: HttpClient
    )
     {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                }
            }
        };

        // Set the defaults
        this.loginFormErrors = {
            email: {},
            password: {}
        };

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */

    onForm() {
        this.profileForm = new FormGroup({
            deliveryNo: new FormControl('', Validators.required),
            postCode: new FormControl('', Validators.required),
            vehicleId: new FormControl('')
        })
    }
    
    drawComplete() {
        debugger;
        // will be notified of szimek/signature_pad's onEnd event
        /* console.log(this.signaturePad.toDataURL());
        console.log(this.signaturePad.fromData); */
        
    }

    drawStart() {
        // will be notified of szimek/signature_pad's onBegin event
        this.imageSrcData = false;
        this.sign = true;
    }
    ngOnInit(): void {
        this.signaturePadOptions;
        
        this.onForm();
        this.vehicleId = this.route.snapshot.paramMap.get('jobId');
        this.isValide = this.vehicleId;


        /*  if (this.jobIdParam) {
             //this.spinner.show();
             //this.getCombineJobData();
             
             //this.jobData = this.jobIdParam;
             //this.jobInputs = false;
             //this.imageSrcData = false;
         }
         else {
             this.imageSrcData = true;
         } */

    }
   /*  getJobData() {
        return this.http.get(APPCONFIG.appUrl + '/epw/getJob?jobId=' + this.vehicleId);

    } */

    public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
        'minWidth': 2,
        'canvasWidth': 250,
        'canvasHeight': 250,
        backgroundColor: '#ffffff', 
        signaturePad:{_ctx:{fillStyle:'#ffffff',}},
        background: '#ffffff',
        fillStyle: '#ffffff',
        penColor: 'rgb(0, 0, 0)',
    };

    clear() {
        //console.log(this.signaturePad.signaturePad._ctx.fillStyle);
        //this.sign = false;
        this.signaturePad.clear();
        this.signaturePadOptions;
        //this.signaturePad.off();
        if (this.imageSrc == undefined) {
            this.imageSrcData = true;
        }

    }
    abortJob(): void {
        
        const dialogRef = this.dialog.open(AbortJobDialog, {
          data: {jobId: this.jobPkId, abortJob: true}
        });
        dialogRef.afterClosed().subscribe(result => {
            debugger;
            this.postDeliverynumber();
            if(result.data == "true"){
                this.postDeliverynumber();
                this.signaturePad.clear();
                this.signaturePadOptions; 
                this.onForm();
            }
        });
       
      }
    
    
    /* abortJob() {
        
       const dialogref =  this.dialog.open(AbortJobDialog, {
            data: {
                jobId: this.jobPkId 
            }
        });
        dialogref.afterClosed
            .subscribe((result) => 
            {   
                debugger;
                this.abortjobDialog.dialogCloseAction.subscribe((r)=> console.log(r)
                );
                this.onDialogClose.emit(this.abortjobDialog.dialogCloseAction);
                console.log(this.onDialogClose.emit(this.abortjobDialog.dialogCloseAction));
            // this.spinner.show();
            this.profileForm.reset();
            this.detailPage = false;
            this.isValide = true;
            this.detailPageSubmit = false;
            this.imageSrcData = false;
            this.imageSrc = null;
            })
    } */
    receiveMessage($event) {
        
        this.message = $event
      }
   /*  getCombineJobData() {
        this.getJobData().subscribe(result => {
            this.spinner.hide();

            this.job = result;
            this.jobApiData = this.job.data;
            this.jobPkId = this.jobApiData
            console.log(this.jobApiData);
            this._router.navigate(['/pages/epw/detail/' + this.vehicleId]);
        },
            err => {
                let title = "Failed to retrive data, Please Click job again";
                this.http1.errorHandler(err, title);
                this.spinner.hide();
            });
    } */

    postData() {
        
        
        
        this.spinner.show();
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'idToken': APPCONFIG.epwToken
            })
        };
        if(this.imageSrc){
            this.dataImg = this.imageSrc.replace(/^data:image\/\w+;base64,/, "");}
            
        else{
            this.dataImg = this.signaturePad.toDataURL('image/jpeg')
        }
        //this.dataImg = this.imageSrc.replace(/^data:image\/\w+;base64,/, "");
        const user = { epwImage: this.dataImg, jobPkId: this.jobPkId.jobPkId };
        
        let body = JSON.stringify(user);
        this.http.post(APPCONFIG.appUrl + '/epw/create', user, httpOptions)
            .subscribe(data => {
                
                
                
                if (data) {
                }
                this.result = data;
                if (this.result.httpStatusCode == 201 || this.result.statusCode == 1) {
                    this.title = "Successfully Submitted";
                    this.confirmDialogRefSession = this.dialog.open(sessionConfirmDialogComponent);
                    this.confirmDialogRefSession.componentInstance.confirmMessage = this.title;
                   // this.getCombineJobData();
                   this.spinner.hide();
                   this.postDeliverynumber();
                   this.signaturePad.clear();
                   this.signaturePadOptions;
                   
                }
                else if (this.result.httpStatusCode == 200 || this.result.statusCode == 1) {
                    this.title = "Successfully Submitted";
                    this.confirmDialogRefSession = this.dialog.open(sessionConfirmDialogComponent);
                    this.confirmDialogRefSession.componentInstance.confirmMessage = this.title;
                   // this.getCombineJobData();
                   this.spinner.hide();
                   this.postDeliverynumber();
                   this.signaturePad.clear();
                   this.signaturePadOptions;
                   
                }
               /*  if (this.result.httpStatusCode == 200 || this.result.statusCode == 1) {
                    this.title = "Successfully Submitted";
                    this.confirmDialogRefSession = this.dialog.open(sessionConfirmDialogComponent);
                    this.confirmDialogRefSession.componentInstance.confirmMessage = this.title;
                    this.spinner.hide();
                    this.profileForm.value = {};
                    this.detailPage = false;
                    this.isValide = true;
                    this.detailPageSubmit = false;
                    this.imageSrcData = false;
                } */
            },
                err => {
                    this.postDataClear = false;
                    let title = "Failed to submit data";
                    this.http1.errorHandler(err, title);
                    this.spinner.hide();
                });
    }
    colorDisabled(imageSrcData) {
        switch (imageSrcData) {
            case true:
                return '#03a9f4';
            case false:
                return 'rgba(0, 0, 0, 0.12) ';
            case undefined:
                return 'rgba(0, 0, 0, 0.12)  '
        }
    }
    ngAfterViewChecked(){
        if(this.postDataClear){
            this.jobPkId = null;
        }
        if(this.jobPkId){
        if(this.jobPkId.jobStatus == 'Completed' || this.jobPkId.jobStatus == 'Cancelled'){
            this.imageSrcData = false;
            this.signaturePad.off();
            
        }}
    }
    onReset() {
        this.imageSrc;
        this.signaturePad.clear();
        this.signaturePad.on();
        this.signaturePad.clear();
        this.signaturePadOptions;
        this.imageSrc = null;
        this.imageSrcData = true;
        this.myInputVariable.nativeElement.value = '';
    }
    close(){
                
                    this.onForm();
                    this.jobApiData = {};
                   this.detailPage = false;
                    this.isValide = true;
                    this.detailPageSubmit = false;
                    this.imageSrcData = false;
                    this.imageSrc = null;
                    this.sign= false;
                    this.postDataClear = true;
                    this.onForm();
    }
    postDeliverynumber() {
        this.spinner.show();
        let body = JSON.stringify(this.profileForm.value);
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'idToken': APPCONFIG.epwToken
            })
        };
        this.http.post(APPCONFIG.appUrl + '/epw/getJob', body, httpOptions)
            .subscribe(data => {
                if (data) {
                    this.spinner.hide();
                }
                
                
                this.result = data;
                this.job = data;
                this.jobApiData = this.job.data;
                this.jobPkId = this.jobApiData
                
                if (this.result.httpStatusCode == 201 || this.result.statusCode == 1) {
                
                    this.detailPage = true;
                    this.isValide = false;
                    this.detailPageSubmit = true;
                    this.imageSrcData = true;
                    this.postDataClear= false;
                    
                }
                if (this.result.httpStatusCode == 200 || this.result.statusCode == 1) {
                    
                    this.detailPage = true;
                    this.isValide = false;
                    this.detailPageSubmit = true;
                    this.imageSrcData = true;
                    this.postDataClear= false;
                    
                }
 
            },
                err => {
                     let title = "";
                     if(err.error.statusCode==2 && err.error.httpStatusCode==400){
                        this.title = "Invalid Details.";
                        this.confirmDialogRefSession = this.dialog.open(sessionConfirmDialogComponent);
                        this.confirmDialogRefSession.componentInstance.confirmMessage = this.title;
                        this.spinner.hide();}
                        else{
                     this.http1.errorHandler(err, title);}
                       this.spinner.hide();
                    /* if(err.statusCode==0 && err.httpStatusCode==400){
                      this.title = err.error.errorMsg;
                      this.confirmDialogRefSession = this.dialog.open(sessionConfirmDialogComponent);
                      this.confirmDialogRefSession.componentInstance.confirmMessage = this.title;
                      this.spinner.hide();
                     
                    }
                    else if(err.error.statusCode==2 && err.error.httpStatusCode==400){
                      this.title = err.error.errorMsg;
                      this.confirmDialogRefSession = this.dialog.open(sessionConfirmDialogComponent);
                      this.confirmDialogRefSession.componentInstance.confirmMessage = this.title;
                      this.spinner.hide();
                     
                    }
                    else if(err.status==400){
                      this.title = "Failed to perform this action";
                      this.confirmDialogRefSession = this.dialog.open(sessionConfirmDialogComponent);
                      this.confirmDialogRefSession.componentInstance.confirmMessage = this.title;
                      this.spinner.hide();
                    }
                    else if(err.status==500){
                      this.title = "Failed to perform this action";
                      this.confirmDialogRefSession = this.dialog.open(sessionConfirmDialogComponent);
                      this.confirmDialogRefSession.componentInstance.confirmMessage = this.title;
                      this.spinner.hide();
                     } */
                }

            );

    }
    onSubmit() {
        debugger;
        this.spinner.show();
        if(this.imageSrc || this.sign)
        {this.postData(); }
        else if (this.profileForm.value.deliveryNo && this.profileForm.value.postCode) {
            
            //this.profileForm.addControl("vehicleId");
            this.profileForm.value.vehicleId = this.vehicleId;
            this.postDeliverynumber();
        }
        

        //console.log(this.profileForm.value.jobId);
        if (this.profileForm.value.jobId) {
            this._router.navigate(['/pages/epw/detail/' + this.profileForm.value.jobId]);
        }
        else {
            //this._router.navigate(['/pages/epw/detail']);
        }
    }
    readURL(event: Event): void {
        
        /* debugger;

        console.log((<HTMLInputElement>event.target).files[0].name);
        (<HTMLInputElement>event.target) = null;
        console.log((<HTMLInputElement>event.target).files[0].name); */
        
        this.spinner.show();
        var bytes = [];
        if(event.type == 'click')
        {this.spinner.hide();
        return;}
        if ((<HTMLInputElement>event.target).files && (<HTMLInputElement>event.target).files[0]) {
            const file = (<HTMLInputElement>event.target).files[0];
            
            this.ng2ImgMax.resizeImage(file, 300, 200).subscribe(
                result => {
                    this.uploadedImage = result;



                    const reader = new FileReader();
                    reader.onload = e => {
                        this.imageSrc = reader.result;
                        this.imageSrcData = false;
                        this.signaturePad.off();

                        for (var i = 0; i < this.imageSrc.length; ++i) {
                            bytes.push(this.imageSrc.charCodeAt(i));
                            bytes.push(0);
                        }
                        this.bytesList = bytes;
                    }
                    reader.readAsDataURL(this.uploadedImage)
                    this.spinner.hide();
                },
                error => {
                    this.spinner.hide();
                })
            /* const reader = new FileReader();
            reader.onload = e => {this.imageSrc = reader.result;
                console.log(this.imageSrc);
                for (var i = 0; i < this.imageSrc.length; ++i)
                {
                    bytes.push(this.imageSrc.charCodeAt(i));
                    bytes.push(0);
                }
                this.bytesList = bytes;
                console.log("bytes",bytes);}
                reader.readAsDataURL(file) */
                
        }
        

    }




    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On form values changed
     */
    onLoginFormValuesChanged(): void {
        for (const field in this.loginFormErrors) {
            if (!this.loginFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.loginFormErrors[field] = {};

            // Get the control
            const control = this.loginForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.loginFormErrors[field] = control.errors;
            }
        }
    }
}
